import $ from "jquery";

$(() => {
  $(".previewButton").click(function () {
    var url = this.dataset.url;
    var $previewBox = $("#preview");
    var formData = $("#message_form").serialize();
    $previewBox.hide();
    $.post(url, formData, function (response) {
      $previewBox.html(response).fadeIn("fast");
    });
    return false;
  });
});
